var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"titan-acl-switch",class:_vm.getStyleClass(),on:{"click":function($event){_vm.$emit('change', !_vm.val); _vm.val = !_vm.val}}},[(_vm.val !== false)?_c('span',[_vm._v(_vm._s(_vm.yes))]):_vm._e(),_vm._v(" "),(_vm.val === false)?_c('span',[_vm._v(_vm._s(_vm.no))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6491166d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/admin/Components/AclSwitch.vue
// module id = null
// module chunks = 